import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useMemo } from 'react';

import type { MergedTransactionType, PortfolioForTransactionsType } from '~/database/supabase/portfolio/types.ts';
import { getPortfolioTransactionsQueryOptions } from '~/server/portfolio/query-options.ts';
import { TransactionTable } from '~/views/portfolio/transactions/transaction-table.tsx';

export const Route = createFileRoute('/portfolios/$portfolioId/transactions')({
	component: PortfolioTransactionsPage,
	loader: ({ context, params }) =>
		context.queryClient.ensureQueryData(getPortfolioTransactionsQueryOptions(Number(params.portfolioId))),
});

function transformPortfolioTransactionsData(portfolio: PortfolioForTransactionsType): MergedTransactionType[] {
	return portfolio.transaction.map(({ instrument, ...transaction }) => ({
		instrument,
		transaction,
	}));
}

function PortfolioTransactionsPage() {
	const { portfolioId } = Route.useParams();
	const { data: loaderData } = useSuspenseQuery(getPortfolioTransactionsQueryOptions(Number(portfolioId)));
	const portfolio = loaderData.activePortfolio;
	const consolidatedData = useMemo(() => (portfolio ? transformPortfolioTransactionsData(portfolio) : []), [portfolio]);

	if (!portfolio) {
		return null;
	}

	return (
		<div className="h-full w-full py-1">
			<TransactionTable mergedData={consolidatedData} userLocale={loaderData.userLocale} />
		</div>
	);
}
